import React from "react";
import { SvgMapMarker } from "@ugitgud/legos/ui/icon/SVG/MapMarker";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";

interface SpotlightFeature {
  title: string;
  description: string;
  imgSrc: string;
}

const spotlightFeatures: SpotlightFeature[] = [
  {
    title: "Live Scouting",
    description: "Identify Strengths and Weakness of your opponents with Dynamic Tagging.",
    imgSrc: "https://static.bigbrain.gg/deadlock/image-assets/ftue/deadlock-live-scouting.png",
  },
  {
    title: "In-Game Tracker",
    description: "Track your Stats and Compare Yourself to the Community Ranked Benchmarks.",
    imgSrc: "https://static.bigbrain.gg/deadlock/image-assets/ftue/deadlock-ingame-tracker.png",
  },
];

export const DeadlockFeatureSpotlight: React.FC = () => {
  return (
    <div className="deadlock-feature-spotlight flex flex-col gap-[48px] mt-[80px] mb-[120px] gap-y-[120px]">
      {spotlightFeatures.map((feature, index) => (
        <div
          key={feature.title}
          className={`spotlight-section flex items-center gap-[60px] ${index % 2 === 1 ? "flex-row-reverse" : ""}`}
        >
          <div className="spotlight-text flex-1 max-w-[354px]">
            <div className="text-white text-[24px] mb-6 font-bold">U.GG Feature Spotlight:</div>
            <div className="flex items-center gap-x-3 mb-[12px]">
              <span className="flex justify-center items-center rounded-[3px] bg-purple-400 w-[26px] h-[26px] shadow-[0_2px_4px_0_rgba(0,0,0,0.25)]">
                <Icon icon={<SvgMapMarker />} className="text-accent-blue-400" />
              </span>
              <h3 className="text-white text-[36px] font-bold">{feature.title}</h3>
            </div>
            <p className="text-lavender-50 text-[18px]">{feature.description}</p>
          </div>
          <div className="spotlight-image">
            <img src={feature.imgSrc} alt={feature.title} className="w-full h-auto max-w-[602px] max-h-[339px] rounded-[6px]" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default DeadlockFeatureSpotlight;
